import { message } from "antd";
import { createContext, useEffect, useState } from "react";
import { ILoadingProvider, IContext } from "./types";


export const LoadingContext = createContext<IContext>({} as IContext)

export const LoadingProvider = ({ children }: ILoadingProvider) => {
  const [loading, setLoading] = useState<number>(0);

  async function addLoading() {
    setLoading(1)
  }

  async function removeLoading() {
    setLoading(0)
  }

  return (
    <LoadingContext.Provider value={{ loading, addLoading, removeLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}